import axios from "utils/axios";

export const getQueues = () => {
  return axios.get("/hr/queues/count");
};
